/**
 * Logo + Starfield — brand HTML builders ported from the prototype
 * `docs/design/flow/ui.jsx` (Splash hero / Room Browser chrome). The Pon blob
 * itself lives in the world kit (`../world/character/ponBlob.ts`) and is
 * re-exported here for the menu screens that show an avatar.
 */

export { ponBlobHtml, type PonBlobOptions } from '../world/character/ponBlob.js';

/** PonPonLand wordmark + tagline (prototype `Logo`). `size` scales it. */
export function logoHtml(size = 1): string {
  return `<div style="display:flex;flex-direction:column;align-items:center;line-height:1">
    <div style="font-family:var(--display);font-weight:700;font-size:${34 * size}px;letter-spacing:.5px;color:#fff7e6;text-shadow:0 ${2 * size}px 0 var(--wood-d), 0 ${3 * size}px 0 var(--wood-d), 0 ${5 * size}px ${8 * size}px rgba(40,24,10,.4)">
      Pon<span style="color:var(--gold)">Pon</span>Land
    </div>
    <div style="font-family:var(--display);font-weight:500;font-size:${11 * size}px;letter-spacing:${6 * size}px;color:var(--leaf-d);margin-top:${3 * size}px;text-transform:uppercase">
      co-op island
    </div>
  </div>`;
}

/** Drifting pollen motes (prototype `Starfield`). */
export function starfieldHtml(n = 26): string {
  let stars = '';
  for (let i = 0; i < n; i++) {
    const left = Math.random() * 100;
    const top = Math.random() * 70;
    const d = Math.random() * 4;
    const s = 2 + Math.random() * 2.5;
    stars += `<div class="star" style="left:${left}%;top:${top}%;animation-delay:${d}s;width:${s}px;height:${s}px"></div>`;
  }
  return `<div class="starfield">${stars}</div>`;
}
